import React from "react";

const GroupTravel = () => {
  return (
    <div className="min-h-screen bg-slate-50 font-sans">
      {/* Split Layout: Image Left, Form Right */}
      <div className="flex flex-col lg:flex-row min-h-screen">
        {/* Left Side: Visuals */}
        <div className="lg:w-5/12 relative min-h-[40vh] lg:min-h-screen hidden sm:block">
          <img
            src="https://images.unsplash.com/photo-1539635278303-d4002c07eae3?auto=format&fit=crop&w=1000&q=80"
            alt="Group of friends traveling"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-slate-900/60 flex flex-col justify-end p-12">
            <h1 className="text-4xl lg:text-5xl font-black text-white mb-4 leading-tight">
              Traveling with 10 or more?
            </h1>
            <p className="text-slate-200 text-lg font-medium">
              Unlock exclusive group rates, flexible payment options, and
              dedicated agent support.
            </p>
          </div>
        </div>

        {/* Right Side: Request Form */}
        <div className="lg:w-7/12 p-6 sm:p-12 lg:p-20 flex flex-col justify-center bg-white">
          <div className="max-w-xl w-full mx-auto">
            <h2 className="text-2xl sm:text-3xl font-black text-slate-900 mb-2">
              Request a Group Quote
            </h2>
            <p className="text-slate-500 text-sm mb-8">
              Fill out the details below and a dedicated group travel expert
              will contact you within 24 hours.
            </p>

            <form className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase mb-2">
                    Leaving From
                  </label>
                  <input
                    type="text"
                    placeholder="Origin City"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-600 outline-none"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase mb-2">
                    Going To
                  </label>
                  <input
                    type="text"
                    placeholder="Destination City"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-600 outline-none"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="sm:col-span-2">
                  <label className="block text-xs font-bold text-slate-700 uppercase mb-2">
                    Departure Date
                  </label>
                  <input
                    type="date"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-600 outline-none"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase mb-2">
                    Passengers
                  </label>
                  <input
                    type="number"
                    min="10"
                    placeholder="10+"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-600 outline-none"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase mb-2">
                  Contact Details
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                  <input
                    type="text"
                    placeholder="Full Name"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-600 outline-none"
                  />
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-600 outline-none"
                  />
                </div>
              </div>

              <button
                type="button"
                className="w-full bg-blue-600 hover:bg-blue-700 active:scale-[0.98] text-white font-black text-lg py-4 rounded-xl transition-all shadow-lg hover:shadow-blue-600/30"
              >
                Submit Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupTravel;
